import { render, staticRenderFns } from "./propostaForm.vue?vue&type=template&id=9c599072&scoped=true&"
import script from "./propostaForm.vue?vue&type=script&lang=js&"
export * from "./propostaForm.vue?vue&type=script&lang=js&"
import style0 from "./propostaForm.vue?vue&type=style&index=0&id=9c599072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c599072",
  null
  
)

export default component.exports